import "../stylesheets/loading.css";

const Loading = () => {
  return <div className="Loading">Loading...</div>;
};

export default Loading;
